import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { AuthorizationModule } from '@wilson/authorization';
import {
  COMPACT_SHIFT_HEIGHT,
  Label,
  MINIMAL_SHIFT_HEIGHT,
  Project,
  ProjectStatus,
  RoleAction,
  RolePermissionSubject,
  Shift,
  ShiftCardBackgroundColor,
  ShiftCategoriesColorCode,
  ShiftCategoriesIdsMap,
  ShiftColorOptions,
  StaffLayoutStyle,
} from '@wilson/interfaces';
import {
  GanttEndingPixelPipe,
  GanttStartingPixelPipe,
  GroupItemsSelectionHelperService,
  IsShiftSelectedPipe,
  ShiftMultiSelectHelperService,
  ShiftPresenceBorderColorPipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  HexWithAlphaPipe,
  ShiftTimelinePipesModule,
} from '@wilson/shift-timeline/pipes';
import { PreferredSettingsStateFacadeService } from '@wilson/shift-timeline/services';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { Observable } from 'rxjs';

@Component({
  selector: 'wilson-loading-shift-card',
  templateUrl: './loading-shift-card.component.html',
  styleUrls: ['./loading-shift-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NzSkeletonModule,
    ShiftTimelinePipesModule,
    HexWithAlphaPipe,
    GanttStartingPixelPipe,
    GanttEndingPixelPipe,
    AuthorizationModule,
    IsShiftSelectedPipe,
    ShiftPresenceBorderColorPipe,
  ],
})
export class LoadingShiftCardComponent implements OnInit {
  private readonly preferredSettingsStateFacadeService = inject(
    PreferredSettingsStateFacadeService,
  );
  protected readonly shiftMultiSelectHelperService = inject(
    ShiftMultiSelectHelperService,
  );
  protected readonly groupItemsSelectionHelperService = inject(
    GroupItemsSelectionHelperService,
  );

  @Input() shift!: Shift & { id: string; isHighlighted: boolean };
  @Input() shiftStartTime!: string;
  @Input() shiftEndTime!: string;
  @Input() project!: Project | null | undefined;
  @Input() label!: Label | null | undefined;

  public shiftCategoriesColorCode = ShiftCategoriesColorCode;
  public ShiftCardBackgroundColor = ShiftCardBackgroundColor;
  public ShiftCategoriesIdsMap = ShiftCategoriesIdsMap;
  public shiftColorOption$!: Observable<ShiftColorOptions>;

  staffLayoutStyle$!: Observable<StaffLayoutStyle>;
  StaffLayoutStyle = StaffLayoutStyle;

  MINIMAL_SHIFT_HEIGHT = MINIMAL_SHIFT_HEIGHT;
  COMPACT_SHIFT_HEIGHT = COMPACT_SHIFT_HEIGHT;
  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;

  protected can = inject(AbilityServiceSignal).can;
  protected ProjectStatus = ProjectStatus;
  protected ShiftColorOptions = ShiftColorOptions;

  ngOnInit(): void {
    this.staffLayoutStyle$ =
      this.preferredSettingsStateFacadeService.staffLayoutStyle$;
    this.shiftColorOption$ =
      this.preferredSettingsStateFacadeService.shiftColorOptions$;
  }
}
